export {
  default as Text,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  CTALink,
} from "./Text";
export { CenteredDiv, Space, CenteredRow, Flex, Grid } from "./Grid";
export { default as Anchor, ExternalAnchor } from "./Anchor";
export { default as Icon } from "./Icon";
export { default as IconMakata } from "./IconMakata";
export { default as Footer } from "./Footer";
export { default as Button } from "./Button";
export { default as NextButton } from "./NextButton";
export { Highlight } from "./styled";
